import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';
import { colors } from '../constants/colors';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

export const IconEye = ({
  width = 24,
  height = 24,
  color = colors.gray2,
  ...rest
}: Props) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      //   xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <G clipPath="url(#clip0_661_723)">
        <Path
          d="M12 16c1.25 0 2.313-.438 3.188-1.313.874-.874 1.312-1.937 1.312-3.187 0-1.25-.438-2.313-1.313-3.188C14.313 7.439 13.25 7 12 7c-1.25 0-2.313.438-3.188 1.313C7.939 9.187 7.5 10.25 7.5 11.5c0 1.25.438 2.313 1.313 3.188C9.687 15.562 10.75 16 12 16zm0-1.8c-.75 0-1.387-.262-1.912-.787A2.604 2.604 0 019.3 11.5c0-.75.262-1.387.787-1.912A2.604 2.604 0 0112 8.8c.75 0 1.387.262 1.912.787.525.526.788 1.163.788 1.913s-.262 1.387-.787 1.912A2.604 2.604 0 0112 14.2zm0 4.8c-2.433 0-4.65-.68-6.65-2.038-2-1.358-3.45-3.179-4.35-5.462.9-2.283 2.35-4.104 4.35-5.463C7.35 4.68 9.567 4 12 4c2.433 0 4.65.68 6.65 2.037 2 1.359 3.45 3.18 4.35 5.463-.9 2.283-2.35 4.104-4.35 5.462C16.65 18.322 14.433 19 12 19zm0-2a9.544 9.544 0 005.188-1.488A9.773 9.773 0 0020.8 11.5a9.773 9.773 0 00-3.613-4.013A9.545 9.545 0 0012 6a9.545 9.545 0 00-5.188 1.487A9.773 9.773 0 003.2 11.5a9.773 9.773 0 003.612 4.012A9.544 9.544 0 0012 17z"
          fill={color}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_661_723">
          <Path fill={color} d="M0 0H24V24H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
